import React, { useRef, useState } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate  } from 'react-router-dom';import Loader from '../../assets/tools/Loder/loader';
const AddUser = () => {
  const fnameRef = useRef();
  const lnameRef = useRef();
  const emailRef = useRef();
  const passRef = useRef();
  const userTypeRef = useRef();
  const history = useNavigate ();
  const [loading , setIsLoading] = useState(false); 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); 

    try {
      const payload = {
        first_name: fnameRef.current.value,
        last_name: lnameRef.current.value,
        middle_name:lnameRef.current.value,
        phone: "+964",
        email: emailRef.current.value,
        position: userTypeRef.current.value, 
        nationality :"Iraqi", 
        country: "Iraq",
        gender:"Male" , 
        organization: "anbar-bcs",
        password: passRef.current.value,
        role: userTypeRef.current.value, 
        active : 1 ,

      };
      console.log(payload); 
      const response = await AxiosClient.post('/Users', payload);
      console.log(response.data); 
      const msg = response.data.message; 
      alert(msg) ; 
      history('/Users');

      
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  return (
    <>
      <div className="card-body px-0 m-2 text-dark m-4">
        <h1 className="h4 m-2">Add new User</h1>
        <form className="form-group" onSubmit={handleSubmit}>
        <label className="form-label">First Name </label>
          <div className="input-group input-group-outline mb-3">
  
            <input type="text" className="form-control" placeholder="First Name" ref={fnameRef} required/>
          </div>

          <label className="form-label">Last Name </label>
          <div className="input-group input-group-outline mb-3">
  
            <input type="text" className="form-control" placeholder="Last Name" ref={lnameRef} required/>
          </div>
          <label htmlFor="Deadline">User Account</label>

          <div className="input-group input-group-outline mb-3">
            <input type="email" className="form-control" placeholder="User mail" ref={emailRef} required />
          </div>
          <div className="input-group input-group-outline mb-3">
            <label className="form-label"></label>
            <input type="password" className="form-control" placeholder="Password" ref={passRef} required />
          </div>

          <label htmlFor="Deadline">user Type</label>

          <div className="input-group input-group-outline mb-3">
            <select className="w-50 input-group-outline p-2" ref={userTypeRef}>
              <option value="Admin">Admin</option>
              <option value="Judge">Judge</option>
              <option value="Media">Media</option>
              <option value="Monitor">Monitor</option>

            </select>
          </div>

          <div className="input-group input-group-outline mb-3">
           {loading ? <Loader label="Creating user..." /> :(  <div className="text-center">
              <button type="submit" className="btn btn-lg bg-gradient-dark btn-lg w-100 mt-4 mb-0">
                ADD New User
              </button>
            </div>) }
          </div>
        </form>
      </div>
    </>
  );
};

export default AddUser;